import Safety from '@shared/svg/safety.svg'
import Search from '@shared/svg/search.svg'
import Time from '@shared/svg/time.svg'
import User from '@shared/svg/user.svg'

export const advantageData = [
	{
		Icon: Safety,
		title: 'Надёжная компания',
		content:
			'Команда Credit.Club работает с 2012 года, мы следуем законам и соблюдаем требования Банка России.',
	},
	{
		Icon: User,
		title: 'Персональный ассистент',
		content: 'Доступен по почте, телефону и в мессенджерах.',
	},
	{
		Icon: Time,
		title: 'Бесплатная оценка недвижимости',
		content: 'Подготовим отчёт об оценке рыночной стоимости объекта за 2 часа.',
	},
	{
		Icon: Search,
		title: 'Юридические консультации',
		content: 'Если потребуется, опытный юрист разберёт договор.',
	},
]
